<div class="task_status_container">
  <!-- Tabs -->
  <div class="ts_tabs">
    <div
      class="ts_tab"
      [class.active]="selectedTab() === 'manage_item'"
      (click)="selectTab('manage_item')"
    >
      {{ config().title }}
    </div>
    @if (config().showTimeSummary) {
    <div
      class="ts_tab"
      [class.active]="selectedTab() === 'time_summary'"
      (click)="selectTab('time_summary')"
    >
      Time Summary
    </div>
    }
  </div>
</div>
<div class="task_tab_content">
  <ng-container
    *ngIf="selectedTab() === 'manage_item'; then manageItem"
  ></ng-container>
  <ng-container
    *ngIf="selectedTab() === 'time_summary'; then timeSummary"
  ></ng-container>
</div>

<!-- AI hours history slider panel (root level so it stacks above layout chrome) -->
@if (showAiHoursLogPanel()) {
<div class="ai-hours-log-slider-backdrop" (click)="closeAiHoursLogPanel()"></div>
<aside class="ai-hours-log-slider" role="dialog" aria-label="AI hour log entries">
  <header class="ai-hours-log-slider__header">
    <div class="ai-hours-log-slider__title-wrap">
      <h3 class="ai-hours-log-slider__title">AI Hour Log</h3>
      <span class="ai-hours-log-slider__total">{{ aiHoursLogHeaderTotalDisplay() }} Hrs</span>
    </div>
    <button type="button" class="ai-hours-log-slider__close" (click)="closeAiHoursLogPanel()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="ai-hours-log-slider__content">
    @if (isLoadingAiHoursLog()) {
    <div class="ai-hours-log-slider__loading"><app-spinner [size]="20"></app-spinner></div>
    } @else if (aiHoursDisplayRows().length === 0) {
    <div class="ai-hours-log-slider__empty">
      <mat-icon>history</mat-icon>
      <span>No records found</span>
    </div>
    } @else {
    <div class="ai-hours-log-table-wrap">
      <table class="ai-hours-log-table" aria-label="AI hour log table">
        <thead>
          <tr>
            <th>User</th>
            <th>Added On</th>
            <th>Hour Saved</th>
           @if (canModifyAiHours()) {
            <th>Action</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of aiHoursDisplayRows(); track row.trackId) {
          <tr>
            <td class="ai-hours-log-table__user" [matTooltip]="getUserName(row.log)" matTooltipPosition="above">
              {{ getUserName(row.log) }}
            </td>
            <td>{{ row.createdAt ? (row.createdAt | date: 'MMM dd, y') : '—' }}</td>
            <td>
              @if (editingAiHoursLogEntryId() === row.trackId) {
              <input
                type="text"
                class="ai-hours-log-entry__input"
                [ngModel]="editingAiHoursLogEntryValue()"
                (ngModelChange)="editingAiHoursLogEntryValue.set($event)"
                maxlength="6"
                pattern="^(\d{1,3})?(\.\d{1,2})?$"
              />
              } @else {
              <span class="ai-hours-log-table__value">{{ formatAiHoursValue(row.hourSaved) }}</span>
              }
            </td>
             
             @if (canModifyAiHours()) {
            <td class="ai-hours-log-table__action">
              @if (isAiHoursLogEntryDeleting(row.trackId)) {
              <span class="ai-hours-log-table__deleting">
                <app-spinner [size]="16"></app-spinner>
              </span>
              } @else {
              <button
                type="button"
                class="ai-hours-log-btn ai-hours-log-btn--delete"
                (mousedown)="$event.preventDefault()"
                (click)="deleteAiHoursLogEntry(row.trackId, $event)"
                [disabled]="deletingAiHoursLogEntryId() !== null"
                matTooltip="Remove entry"
                matTooltipPosition="above"
                aria-label="Remove AI hour entry"
              >
                <mat-icon>delete</mat-icon>
              </button>
              }
            </td>
            }
          </tr>
          }
        </tbody>
      </table>
    </div>
    }
  </div>
</aside>
}

<ng-template #manageItem>
  <!-- Assigned To -->
  <div class="assigned_wrap">
    <div class="ts_section_title_row">
      <div class="ts_section_title">
        {{ config().assignLabel }}
      </div>
      <button
        type="button"
        class="ts_add_inline"
        (click)="openAssignModal()"
        title="Add assignee"
        aria-label="Add assignee"
      >
        <span class="add_wrap" aria-hidden="true">
          <svg
            width="13"
            height="14"
            viewBox="0 0 13 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.55042 0.743805C6.27845 0.743805 6.05798 0.964274 6.05798 1.23624V6.40677H0.887451C0.615481 6.40677 0.39502 6.62723 0.39502 6.8992C0.39502 7.17117 0.615481 7.39163 0.887451 7.39163H6.05798V12.5622C6.05798 12.8341 6.27845 13.0546 6.55042 13.0546C6.82238 13.0546 7.04285 12.8341 7.04285 12.5622V7.39163H12.2134C12.4853 7.39163 12.7058 7.17117 12.7058 6.8992C12.7058 6.62723 12.4853 6.40677 12.2134 6.40677H7.04285V1.23624C7.04285 0.964274 6.82238 0.743805 6.55042 0.743805Z"
            />
          </svg>
        </span>
      </button>
    </div>
    <div
      class="ts_assigned_list"
      [class.ts_assigned_list--empty]="showUnassignedLabel() || showAssignedListLoader()"
    >
      @if (showAssignedListLoader()) {
      <div class="ts_assigned_list_loader" aria-busy="true" aria-live="polite">
        <app-spinner [size]="20"></app-spinner>
      </div>
      }
      @if (showUnassignedLabel()) {
      <span class="ts_unassigned_label">Unassigned</span>
      }
      @for (user of visibleAssignedUsers(); track user._id) {
      <div class="ts_assigned_card">
        <div class="ts_avatar">
          <!-- <span class="act_grn_icon"></span> -->
          <img
            [src]="user.image || 'assets/images/avatar.png'"
            [alt]="user.name"
            onerror="
              this.onerror = null;
              this.src = 'assets/images/avatar.png';
            "
          />
        </div>
        <div
          class="ts_name"
          [appCopyableTruncateTooltip]="user.name"
        >{{ user.name }}</div>
        @if (!isStatusComplete()) {
        <button
          class="ts_remove_btn"
          (click)="openRemoveConfirmPopup(user)"
          title="Remove user"
        >
          <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.938477 1.02026L7.16113 7.24292"
              stroke-width="0.541101"
            />
            <path
              d="M7.16113 1.02026L0.938476 7.24292"
              stroke-width="0.541101"
            />
          </svg>
        </button>
        }
      </div>
      }
    </div>
    @if (hasMoreAssignedUsers()) {
    <button
      type="button"
      class="ts_assigned_more_btn"
      (click)="toggleAssignedListExpand()"
    >
      {{ showAllAssignedUsers() ? 'Show less' : '+' + hiddenAssignedCount() + ' More' }}
      <mat-icon aria-hidden="true">{{ showAllAssignedUsers() ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
    }

    <!-- Expandable Assignee Selection -->
    <app-assignee-selection-expand
      [expanded]="showAssignExpand()"
      [allAssignableData]="allAssignableData()"
      [assignedUsers]="assignedUsers()"
      [isLoadingData]="isLoadingData()"
      [config]="{
        title: 'Assign',
        placeholder: 'Add assignee',
        confirmText: 'Assign',
        cancelText: 'Cancel',
        loadingText: 'Loading...',
        noResultsText: 'No assignees found',
        noChangesMessage: 'No changes made to assignees'
      }"
      (assignUsers)="onAssignUsers($event)"
      (collapse)="closeAssignExpand()"
    >
    </app-assignee-selection-expand>

    <!-- @if (childExist()) {
    <p class="ts_parent_disabled_note">
      <i class="wl_icon_hint" aria-hidden="true"></i>
      <span>This field is disabled for parent task</span>
    </p>
    } -->
  </div>

  <!-- Info Cards -->
  <div class="ts_info_cards ts_info_cards--meta">
    <div class="ts_info_card ts_info_card--with-icon">
      <span class="ts_info_icon ts_info_icon--update" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3.5" y="5" width="17" height="15.5" rx="2"></rect>
          <path d="M8 3.5v3.5M16 3.5v3.5M3.5 10h17"></path>
        </svg>
      </span>
      <div class="ts_info_text">
        <div class="ts_info_label">Last Update</div>
        <div class="ts_info_value">
          {{ itemDetails()?.updatedBy?.updatedAt ?
          (itemDetails()?.updatedBy?.updatedAt | date:'MMM d, y') : (itemDetails()?.updatedAt | date:'MMM d, y') }}
        </div>
      </div>
    </div>
    <div class="ts_info_card ts_info_card--with-icon">
      <span class="ts_info_icon ts_info_icon--submit" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 15.5V5"></path>
          <path d="M8 9l4-4 4 4"></path>
          <path d="M5 19h14"></path>
        </svg>
      </span>
      <div class="ts_info_text">
        <div class="ts_info_label">Submitted On</div>
        <div class="ts_info_value">
          {{itemDetails()?.createdAt | date: 'MMM d, y'}}
        </div>
      </div>
    </div>
    <div class="ts_info_card ts_info_card--with-icon">
      <span class="ts_info_icon ts_info_icon--created" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="8" r="3.2"></circle>
          <path d="M5.4 19c1.3-3.3 3.6-5 6.6-5s5.3 1.7 6.6 5"></path>
        </svg>
      </span>
      <div class="ts_info_text">
        <div class="ts_info_label">Created By</div>
        <div
          class="ts_info_value"
          [matTooltip]="itemDetails()?.createdBy?.name || 'Unknown'"
          matTooltipPosition="above"
          matTooltipClass="custom-tooltip"
        >
          {{itemDetails()?.createdBy?.name || 'Unknown'}}
        </div>
      </div>
    </div>
    @if (config().showDueDate) {
    <div
      class="ts_info_card ts_info_card--with-icon tsk_due_on"
      [class.ts_info_card--due-clickable]="
        !childExist() && !isStatusComplete()
      "
      (click)="onDueDateCardClick()"
    >
      <span class="ts_info_icon ts_info_icon--due" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3.2" y="4.8" width="13.2" height="13.5" rx="2"></rect>
          <path d="M7.2 3.2v3.2M12.4 3.2v3.2M3.2 9.2h13.2"></path>
          <circle cx="17.2" cy="16.6" r="4.2"></circle>
          <path d="M17.2 14.8v2.1l1.4.9"></path>
        </svg>
      </span>
      <div class="ts_info_text">
        <div class="ts_info_label">{{ config().dueDateLabel || 'Due on' }}</div>
        <div class="ts_info_value ts_link">
          {{
            selectedDate()
              ? (selectedDate() | date: 'MMM d, y')
              : 'Select Date'
          }}
          @if (!childExist() && !isStatusComplete()) {
          <span
            class="ts_edit_icon"
            [class.disabled]="isStatusComplete()"
          >
            @if (isUpdatingDate()) {
            <app-spinner [size]="16"></app-spinner>
            }
            @if (!isUpdatingDate()) {
            <svg
              width="10"
              height="10"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.16122 12.9482H9.29339L17.1899 5.05161C17.4886 4.75299 17.6491 4.38624 17.6491 3.97284C17.6491 3.55944 17.4886 3.16936 17.1899 2.89407L15.2386 0.942772C14.94 0.644154 14.5733 0.483643 14.1599 0.483643C13.7465 0.483643 13.3564 0.644159 13.0811 0.942772L5.16113 8.81614L5.16122 12.9482ZM13.7008 1.58473C13.9304 1.35516 14.3438 1.33184 14.5733 1.58473L16.5246 3.53602C16.7775 3.78891 16.7775 4.17899 16.5246 4.40855L15.3535 5.5797L12.5305 2.75583L13.7008 1.58473ZM6.07948 9.20604L11.8877 3.39783L14.7116 6.2217L8.90335 12.0299H6.07948V9.20604Z"
              ></path>
              <path
                d="M0.959494 4.56893V13.8206C0.959494 15.7262 2.52072 17.2875 4.42638 17.2875H13.4251C15.3306 17.2875 16.892 15.7263 16.892 13.8206V8.88497H15.9737V13.8206C15.9737 15.2213 14.8259 16.3692 13.4251 16.3692H4.40296C3.00225 16.3692 1.85434 15.2214 1.85434 13.8206L1.85523 4.56893C1.85523 3.16822 3.00306 2.02031 4.40386 2.02031H9.08651V1.10205L4.40294 1.10295C2.49737 1.12537 0.959494 2.6633 0.959494 4.56893Z"
              ></path>
            </svg>
            }
          </span>
          }
        </div>
      </div>
      <input
        class="ts_due_datepicker_input"
        [matDatepicker]="picker"
        [matDatepickerFilter]="dateFilter"
        [ngModel]="selectedDate()"
        (ngModelChange)="selectedDate.set($event)"
        (dateChange)="onDateChange($event)"
      />
      <mat-datepicker #picker></mat-datepicker>
    </div>
    }
  </div>

  <!-- Planned Hours -->
  @if (config().showPlannedHours) {
  <div
    class="ts_info_cards plan_w100"
  >
    <div class="ts_info_card">
      <span class="ts_ph_icon">
        <svg
          width="18"
          height="20"
          viewBox="0 0 18 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.55312 2.16873C3.94438 2.21883 0.187256 5.97595 0.187256 10.6348C0.187256 15.2936 3.99448 19.1008 8.65331 19.1008C13.3121 19.1008 17.1194 15.2936 17.1194 10.6348C17.1194 9.63289 16.919 8.58089 16.5683 7.62909C16.3178 7.02795 15.366 7.37861 15.6165 7.97975C15.9171 8.83137 16.1175 9.73308 16.1175 10.6348C16.1175 14.7426 12.7611 18.0989 8.65331 18.0989C4.54552 18.0989 1.18916 14.7426 1.18916 10.6348C1.18916 6.527 4.49543 3.22073 8.55312 3.17063L7.30075 4.4731C6.84989 4.92396 7.55122 5.62529 8.00208 5.17443L10.1562 3.02035C10.3064 2.87006 10.3064 2.5194 10.1562 2.31902L8.00208 0.215029C7.55122 -0.235826 6.84989 0.465504 7.30075 0.916359L8.55312 2.16873Z"
          />
          <path
            d="M5.0965 10.685C4.64564 10.2341 5.34697 9.4827 5.79783 9.98365L7.60125 11.737L11.4586 7.82956C11.9094 7.37871 12.6608 8.08004 12.1599 8.58099L7.95191 12.789C7.75153 12.9893 7.40087 12.9893 7.25058 12.789L5.0965 10.685Z"
          />
        </svg>
      </span>
      <div
        class="input_wrap"
        (click)="!isStatusComplete() && onClickInside($event)"
      >
        @if (!showInput()) {
        <span
          (click)="!isStatusComplete() && enableInput()"
          [style.cursor]="childExist() || isStatusComplete() ? 'default' : 'pointer'"
        >
          {{ config().plannedHoursLabel || 'Planned Hrs*' }}
          <span class="ts_ph_value">{{ displayPlannedHours() }}</span>
          <!-- info icon here  -->
          @if (plannedHoursHistory().length > 0) {
          <span
            #plannedHoursHintIconWrapper
            class="hint_icon_wrapper"
            tabindex="0"
            (mouseenter)="onPlannedHoursHintEnter()"
            (mouseleave)="onPlannedHoursHintLeave($event)"
            (focus)="onPlannedHoursHintEnter()"
            (blur)="onPlannedHoursHintLeave()"
          >
            <i class="wl_icon_hint hint-icon"></i>
            @if (showPlannedHoursTooltip()) {
            <div
              #plannedHoursTooltip
              class="goal-date-tooltip new-format completion-log-tooltip"
              [ngClass]="{ 'invisible': !plannedHoursTooltipPositioned() }"
              (mousedown)="onCompletionLogTooltipPointerBlock($event)"
              (click)="onCompletionLogTooltipPointerBlock($event)"
              (mouseenter)="onPlannedHoursHintEnter()"
              (mouseleave)="onPlannedHoursHintLeave($event)"
            >
              <div class="completion-log-tooltip__header">
                PLANNED HOURS LOG
              </div>
              <div class="completion-log-tooltip__body">
                @if (plannedHoursHistory().length === 0) {
                <div class="completion-log-tooltip__empty">
                  <mat-icon class="completion-log-tooltip__empty-icon"
                    >history</mat-icon
                  >
                  <span>No records found</span>
                </div>
                } @else { @for (row of plannedHoursHistory(); track row) {
                <div class="completion-log-tooltip__entry">
                  <div class="completion-log-tooltip__change">
                    <span class="completion-log-tooltip__date"
                      >{{ row?.oldValue }} Hrs</span
                    >
                    <span
                      class="completion-log-tooltip__arrow"
                      aria-hidden="true"
                      >→</span
                    >
                    <span
                      class="completion-log-tooltip__date completion-log-tooltip__date--emphasis"
                      >{{ row?.newValue }} Hrs</span
                    >
                  </div>
                  <div class="completion-log-tooltip__meta">
                    <span>{{ row?.changedBy }}</span>
                    <span class="completion-log-tooltip__sep">·</span>
                    <span>{{ row?.changedOn | date:'MMM d, y, h:mm a' }}</span>
                  </div>
                  @if (row?.reason) {
                  <div class="completion-log-tooltip__reason">
                    <span class="completion-log-tooltip__reason-label"
                      >Reason:</span
                    >
                    <span class="completion-log-tooltip__reason-text"
                      >{{ row?.reason }}</span
                    >
                  </div>
                  }
                </div>
                } }
              </div>
            </div>
            }
          </span>
          }

          @if (!childExist() && !isStatusComplete() && !isUpdatingPlannedHours()) {
          <span
            class="ts_edit_icon"
            [class.disabled]="isStatusComplete()"
            (click)="showInput.set(true)"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.16122 12.9482H9.29339L17.1899 5.05161C17.4886 4.75299 17.6491 4.38624 17.6491 3.97284C17.6491 3.55944 17.4886 3.16936 17.1899 2.89407L15.2386 0.942772C14.94 0.644154 14.5733 0.483643 14.1599 0.483643C13.7465 0.483643 13.3564 0.644159 13.0811 0.942772L5.16113 8.81614L5.16122 12.9482ZM13.7008 1.58473C13.9304 1.35516 14.3438 1.33184 14.5733 1.58473L16.5246 3.53602C16.7775 3.78891 16.7775 4.17899 16.5246 4.40855L15.3535 5.5797L12.5305 2.75583L13.7008 1.58473ZM6.07948 9.20604L11.8877 3.39783L14.7116 6.2217L8.90335 12.0299H6.07948V9.20604Z"
              ></path>
              <path
                d="M0.959494 4.56893V13.8206C0.959494 15.7262 2.52072 17.2875 4.42638 17.2875H13.4251C15.3306 17.2875 16.892 15.7263 16.892 13.8206V8.88497H15.9737V13.8206C15.9737 15.2213 14.8259 16.3692 13.4251 16.3692H4.40296C3.00225 16.3692 1.85434 15.2214 1.85434 13.8206L1.85523 4.56893C1.85523 3.16822 3.00306 2.02031 4.40386 2.02031H9.08651V1.10205L4.40294 1.10295C2.49737 1.12537 0.959494 2.6633 0.959494 4.56893Z"
              ></path>
            </svg>
          </span>
          }
          @if (isUpdatingPlannedHours()) {
          <span>
            <app-spinner [size]="16"></app-spinner>
          </span>
          }
        </span>
        }
        @if (showInput()) {
        <input
          type="text"
          [ngModel]="inputValue()"
          (ngModelChange)="inputValue.set($event)"
          placeholder="Enter Planned Hours"
          #inputBox
          maxlength="4"
          (keypress)="allowOnlyDecimalNumbers($event)"
          (keydown)="onInputKeyDown($event)"
          (blur)="onInputBlur($event)"
          (mousedown)="onInputMouseDown($event)"
          (mouseup)="onInputMouseUp($event)"
          (selectstart)="onInputSelectStart($event)"
        />
        }
      </div>
    </div>
  </div>
  }

  <!-- AI Hours -->
  @if (selectedStatusValue()?.toLowerCase() !== 'new') {
  <div
    class="ts_info_cards plan_w100 ai_hrs_wrap"
  >
    <div class="ts_info_card">
      <span class="ts_ph_icon">
        <i class="wl_icon_ai-hour"></i>
      </span>
      <div
        class="input_wrap"
        (click)="canModifyAiHours() && onClickInside($event)"
      >
        @if (!aiHoursEditing()) {
        <span
          (click)="canModifyAiHours() && startAiHoursEdit()"
        >
          AI Hours <span class="ts_ph_value">{{ aiHoursSidebarDisplay() }} Hrs</span>
          @if (showAiHoursHistoryHint()) {
          <span
            #aiHoursLogIconWrapper
            class="hint_icon_wrapper"
            tabindex="0"
            matTooltipAlways
            [matTooltip]="'Click here to open AI hour history and manage each entry.'"
            matTooltipPosition="above"
            (click)="openAiHoursLogPanel($event)"
          >
            <i class="wl_icon_hint hint-icon"></i>
          </span>
          }
          @if (!isStatusComplete() || isStatusPendingApproval()) {
          <span
            class="ts_edit_icon"
            [class.disabled]="!canModifyAiHours()"
            (click)="$event.stopPropagation(); canModifyAiHours() && startAiHoursEdit()"
            [matTooltip]="canEditAiHours() ? '' : 'Only assignees can edit AI hours'"
            matTooltipPosition="above"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.16122 12.9482H9.29339L17.1899 5.05161C17.4886 4.75299 17.6491 4.38624 17.6491 3.97284C17.6491 3.55944 17.4886 3.16936 17.1899 2.89407L15.2386 0.942772C14.94 0.644154 14.5733 0.483643 14.1599 0.483643C13.7465 0.483643 13.3564 0.644159 13.0811 0.942772L5.16113 8.81614L5.16122 12.9482ZM13.7008 1.58473C13.9304 1.35516 14.3438 1.33184 14.5733 1.58473L16.5246 3.53602C16.7775 3.78891 16.7775 4.17899 16.5246 4.40855L15.3535 5.5797L12.5305 2.75583L13.7008 1.58473ZM6.07948 9.20604L11.8877 3.39783L14.7116 6.2217L8.90335 12.0299H6.07948V9.20604Z"
              ></path>
              <path
                d="M0.959494 4.56893V13.8206C0.959494 15.7262 2.52072 17.2875 4.42638 17.2875H13.4251C15.3306 17.2875 16.892 15.7263 16.892 13.8206V8.88497H15.9737V13.8206C15.9737 15.2213 14.8259 16.3692 13.4251 16.3692H4.40296C3.00225 16.3692 1.85434 15.2214 1.85434 13.8206L1.85523 4.56893C1.85523 3.16822 3.00306 2.02031 4.40386 2.02031H9.08651V1.10205L4.40294 1.10295C2.49737 1.12537 0.959494 2.6633 0.959494 4.56893Z"
              ></path>
            </svg>
          </span>
          }
          @if (isUpdatingAiHours()) {
          <span>
            <app-spinner [size]="16"></app-spinner>
          </span>
          }
        </span>
        }

        @if (aiHoursEditing()) {
        <div class="ai-hours-edit-wrap">
        <input
          #aiHoursInputRef
          type="text"
          class="ai-hours-input"
          [ngModel]="aiHoursInputValue()"
          (ngModelChange)="onAiHoursInputChange($event)"
          (focus)="aiHoursFocused.set(true)"
          (blur)="onAiHoursBlur()"
          (keypress)="onAiHoursKeypress($event)"
          (keydown)="onAiHoursKeyDown($event)"
          (paste)="onAiHoursPaste($event)"
          placeholder="0"
          maxlength="5"
          pattern="^(\d{1,3})?(\.\d{1,2})?$"
          [attr.aria-describedby]="'ai-hours-max-hint'"
        />
        <span
            id="ai-hours-max-hint"
            class="ai-hours-max-hint"
            tabindex="0"
            role="img"
            [attr.aria-label]="'Max allowed: ' + AI_HOURS_MAX + ' hours'"
            [matTooltip]="'Max allowed: ' + AI_HOURS_MAX + ' hours'"
            matTooltipPosition="above"
            matTooltipClass="custom-tooltip"
          >
            <i class="wl_icon_hint hint-icon" aria-hidden="true"></i>
          </span>
        </div>
        }
      </div>
    </div>
  </div>
  }

  <!-- Status -->
  <div class="ng_task_wrap" [style.background-color]="statusColor + '20'">
    <label class="status-label">{{ config().statusLabel }}</label>
    <div
      class="status-select-wrapper"
      [class.loading]="isUpdatingStatus()"
      style="position: relative"
    >
      <ng-select
        [items]="statusListWithApproval()"
        bindLabel="label"
        bindValue="value"
        [ngModel]="selectedStatus()"
        (ngModelChange)="selectedStatus.set($event); onStatusChange($event)"
        [searchable]="false"
        class="custom-ng-select"
      >
        <ng-template ng-label-tmp>
          <span [style.color]="statusColor">{{ statusLabel }}</span>
        </ng-template>
      </ng-select>
      @if (isUpdatingStatus()) {
      <div class="status-spinner-overlay">
        <app-spinner [size]="16"></app-spinner>
      </div>
      }
    </div>
    <!-- <small class="form-text text-muted" *ngIf="childExist()"
      style="display: block; margin-top: 8px; font-size: 12px; color: #6b7280;">
      This field is disabled for parent task
    </small> -->
  </div>
  @if (showUpdateAsCompletedButton()) {
  <button
    class="ts_done_my_part_btn"
    type="button"
    (click)="updateItemAsCompleted()"
    [disabled]="isUpdatingAsCompleted()"
    matTooltip="Marks only your assignment as complete. This item stays open until the other assignees finish their work."
    matTooltipAlways
    matTooltipPosition="above"
    matTooltipClass="custom-tooltip"
  >
    @if (isUpdatingAsCompleted()) {
    <app-spinner [size]="16"></app-spinner>
    }
    @if (!isUpdatingAsCompleted()) {
    <i class="wl_icon_complete" aria-hidden="true"></i>
    }
    <span>Done with my part</span>
  </button>
  }

  <!-- Approvals -->
  @if (config().showApprovals && (!approvalPaths() || !approvalPaths().stages || approvalPaths().stages.length === 0) && !isStatusComplete()) {
  <button
    class="ts_approvals_toggle"
    (click)="openApprovalsModal()"
  >
   <i class="wl_icon_complete" aria-hidden="true"></i>
    {{ approvalExists() ? 'Modify Approval' : 'Set Approvals' }}
    <div class="ts_dropdown_arrow">
      <svg
        width="10"
        height="6"
        viewBox="0 0 10 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.667969 0.947857L4.62812 4.90801L8.58827 0.947857"
          stroke="white"
          stroke-width="1.18805"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg>
    </div>
  </button>
  }
  @if (config().showApprovals && approvalPaths() && approvalPaths().stages && approvalPaths().stages.length > 0) {
  <div
    class="ts_approvals"
  >
    <div class="ts_approvals_stepper_wrapper">
      <div class="ts_custom_stepper">
        <div class="ts_stepper_content">
          <div class="ts_stepper_header">
            @for (step of visibleStepsArray; track $index; let i = $index) {
            <div
              class="ts_stepper_step"
              [class.active]="(visibleStepStart + i) === activeStep"
            >
              <div class="ts_stepper_label" [title]="step.label">
                {{ step.label }}
              </div>
              <div
                class="ts_stepper_status"
                [class.active]="(visibleStepStart + i) === activeStep"
              >
                {{ step.status }}
              </div>
            </div>
            }
          </div>
        </div>

        <div class="ts_stepper_line_row">
          <button
            class="ts_stepper_arrow"
            (click)="prevStep()"
            [disabled]="!canGoPrev()"
          >
            <svg
              viewBox="0 0 5 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.76294 0.419495L1.06806 3.11438L3.76294 5.80926"
                stroke-width="0.808464"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <div class="ts_stepper_dots">
             @for (step of visibleStepsArray; track $index; let i = $index) {
              <div
                class="ts_stepper_dot"
                [class.active]="(visibleStepStart + i) === activeStep"
              ></div>
              @if (i < (visibleStepsArray.length - 1)) {
              <div
                class="ts_stepper_line"
              ></div>
              }
            }
          </div>
          <button
            class="ts_stepper_arrow"
            (click)="nextStep()"
            [disabled]="!canGoNext()"
          >
            <svg
              viewBox="0 0 5 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.12891 0.419495L3.82379 3.11438L1.12891 5.80926"
                stroke-width="0.808464"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
 @if(displayApprovalRejectButton()) {
    <div class="ts_approvals_actions">
      <button
        class="ts_approve_btn"
        (click)="openApproveConfirmPopup()"
        [disabled]="isApprovingApproval() || isRejectingApproval()"
      >
        <span>Approve</span>
      </button>
      <button
        class="ts_reject_btn"
        (click)="openRejectConfirmPopup()"
        [disabled]="isApprovingApproval() || isRejectingApproval()"
      >
        <span>Reject</span>
      </button>
    </div>
    }
  </div>
  }

  <!-- Ref No -->
  @if (config().showRefNumber) {
  <div class="ts_refno">
    {{ config().refNumberLabel || 'Ref No.' }} :
    <span class="ts_copy_wrap">
      <button
        type="button"
        class="ts_refno_copy"
        title="Copy reference number"
        aria-label="Copy reference number"
        (click)="copyRefNo($event)"
      >
        <span class="ts_refno_value">{{ itemReferenceNumber() }}</span>
        <span class="ts_copy_btn" aria-hidden="true">
        <svg
          width="9"
          height="10"
          viewBox="0 0 9 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M5.54931 1.55231H1.94971C1.28711 1.55231 0.749512 2.0899 0.749512 2.7525V8.3526C0.749512 9.0152 1.28711 9.55279 1.94971 9.55279H5.54981C6.21241 9.55279 6.75001 9.0152 6.75001 8.3526L6.74952 2.7525C6.74952 2.0899 6.21191 1.55231 5.54931 1.55231ZM6.24951 8.35202C6.24951 8.73972 5.93701 9.05222 5.54931 9.05222H1.94971C1.56201 9.05222 1.24951 8.73972 1.24951 8.35202V2.75243C1.24951 2.36473 1.56201 2.05223 1.94971 2.05223H5.54981C5.93751 2.05223 6.25001 2.36473 6.25001 2.75243L6.24951 8.35202Z"
            fill="#979BA8"
          />
          <path
            d="M7.04931 0.0523071H3.44971C2.78711 0.0523071 2.24951 0.589905 2.24951 1.2525H2.74951C2.74951 0.864803 3.06201 0.552305 3.44971 0.552305H7.04981C7.43751 0.552305 7.75001 0.864803 7.75001 1.2525V6.8526C7.75001 7.2403 7.43751 7.5528 7.04981 7.5528V8.05279C7.71241 8.05279 8.25001 7.5152 8.25001 6.8526L8.24952 1.2525C8.24952 0.589905 7.71191 0.0523071 7.04931 0.0523071Z"
            fill="#979BA8"
          />
        </svg>
        </span>
      </button>
      @if (copiedField() === 'ref') {
      <span class="cpy_text">Copied</span>
      }
    </span>
    @if (itemDetailsLink()) {
    <span class="ts_refno_sep" aria-hidden="true"></span>
    <span class="ts_copy_wrap">
      <button
        type="button"
        class="ts_copy_link_btn"
        title="Copy linked reference number"
        aria-label="Copy linked reference number"
        (click)="copyItemLink($event)"
      >
        <mat-icon aria-hidden="true">link</mat-icon>
      </button>
      @if (copiedField() === 'link') {
      <span class="cpy_text">Copied</span>
      }
    </span>
    }
  </div>
}
</ng-template>


<ng-template #timeSummary>
  <div class="task-time-summary-container">
    <!-- Task Hours Status Card -->
    <div class="status-card">
      <h3 class="task-hours-status-title">{{ getStatusCardTitle() }}</h3>

      <div class="status-container">
        <div class="chart-section">
          <!-- Task Status Chart -->
          <div class="donut-container task_stat_donut">
            <div class="gauge-wrapper">
              <div #taskStatusChartContainer class="gauge-chart"></div>
              <!-- Loading spinner overlay -->
              @if (isChartsLoading()) {
              <div class="spinner-only" >
                <app-spinner [size]="30"></app-spinner>
              </div>
              }
            </div>
            <div class="caption">{{ getStatusChartCaption() }}</div>
          </div>

          <!-- Balance Hours Chart -->
          <div class="donut-container balance_hrs_donut">
            <div class="gauge-wrapper">
              <div #balanceHoursChartContainer class="gauge-chart"></div>
              <!-- Loading spinner overlay -->
              @if (isChartsLoading()) {
              <div class="spinner-only">
                <app-spinner [size]="30"></app-spinner>
              </div>
              }
            </div>
          </div>
        </div>

        <div class="info-section">
          <ul class="stats">
            <li class="light">
              <span>Planned Hrs :</span>
              <b>{{ formatHours(taskHourStatus()?.totalPlannedHours) }}</b>
            </li>
            <li class="green">
              <span>Hours Filled :</span>
              <b>{{ formatHours(taskHourStatus()?.hourFilledData) }}</b>
            </li>
            <li class="blue">
              <span>Unfilled Hours :</span>
              <b>{{ formatHours(taskHourStatus()?.unfilledHours) }}</b>
            </li>
            <li class="pink">
              <span>Offset Hours :</span>
              <b>{{ formatHours(taskHourStatus()?.offsetHours) }}</b>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<app-assignee-selection-slider
  [show]="showAssignModal()"
  [allAssignableData]="allAssignableData()"
  [assignedUsers]="assignedUsers()"
  [isLoadingData]="isLoadingData()"
  [config]="{
    title: 'Assign Users',
    placeholder: 'Search and select assignees...',
    confirmText: 'Assign Users',
    cancelText: 'Cancel',
    loadingText: 'Loading...',
    noResultsText: 'No assignees found',
    noChangesMessage: 'No changes made to assignees'
  }"
  (assignUsers)="onAssignUsers($event)"
  (close)="closeAssignModal()"
></app-assignee-selection-slider>

<app-confirm-popup
  [show]="showRemoveConfirmPopup()"
  [config]="{
    title: 'Remove User',
    message: 'Are you sure you want to remove this user from the item?',
    type: 'warning',
    showCancel: true,
    cancelText: 'Cancel',
    confirmText: 'Remove',
    loading: isRemovingAssignee()
  }"
  (confirm)="confirmRemoveAssignedUser()"
  (cancel)="cancelRemoveAssignedUser()"
></app-confirm-popup>

<app-confirm-popup
  [show]="showDeleteApprovalConfirmPopup()"
  [config]="{
    title: 'Delete Approval',
    message: 'Are you sure you want to delete this approval process? This action cannot be undone.',
    type: 'delete',
    showCancel: true,
    cancelText: 'Cancel',
    confirmText: 'Delete',
    loading: isLoadingApprovals()
  }"
  (confirm)="confirmDeleteApproval()"
  (cancel)="cancelDeleteApproval()"
></app-confirm-popup>

<app-confirm-popup
  [show]="showApprovalRemoveStageConfirmPopup()"
  [config]="approvalRemoveStageConfirmConfig()"
  (confirm)="confirmRemoveApprovalStage()"
  (cancel)="cancelRemoveApprovalStage()"
></app-confirm-popup>


<app-confirm-popup
  [show]="showApproveConfirmPopup()"
  [config]="{
    title: 'Approve',
    message: 'Are you sure you want to approve this request?',
    type: 'success',
    showCancel: true,
    cancelText: 'Cancel',
    confirmText: 'Approve',
    loading: isApprovingApproval()
  }"
  (confirm)="approveApproval()"
  (cancel)="cancelApproveConfirmPopup()"
></app-confirm-popup>

<app-confirm-popup
  [show]="showRejectConfirmPopup()"
  [config]="{
    title: 'Reject',
    message: 'Are you sure you want to reject this request?',
    type: 'warning',
    showCancel: true,
    cancelText: 'Cancel',
    confirmText: 'Reject',
    loading: isRejectingApproval(),
    showReasonInput: true,
    reasonLabel: 'Reason',
    reasonPlaceholder: 'Enter rejection reason (optional)'
  }"
  (confirm)="rejectApproval($event)"
  (cancel)="cancelRejectConfirmPopup()"
></app-confirm-popup>
<!-- Comprehensive Approvals Modal Slider -->
@if (showApprovalsModal()) {
<div
  class="approvals_modal_overlay"
  (click)="closeApprovalsModal()"
>
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>
        <span class="approval-icon-wrap approval-icon-wrap--stages" aria-hidden="true">
          <i class="wl_icon_approvals"></i>
        </span>
        {{ singleApprovalData() ? 'Modify Approvals' : 'Set Approvals' }}
      </h3>
      <button type="button" class="close-button" (click)="closeApprovalsModal()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="modal-content">
      <!-- Approval Selection Section - Only show when no approval is selected and no single approval data -->
      @if (!selectedApproval() && !singleApprovalData()) {
      <div
        class="approval-selection"
      >
        <div class="approval-dropdown-container">
          <ng-select
            [items]="approvalList()"
            bindLabel="name"
            bindValue="_id"
            [ngModel]="selectedApproval()"
            (ngModelChange)="onApprovalChange($event)"
            [searchable]="true"
            [clearable]="true"
            [placeholder]="'Select an approval process'"
            [loading]="isLoadingApprovals()"
            class="approval-dropdown"
          >
            <ng-template ng-option-tmp let-item="item">
              <div class="approval-option">
                <span>{{ item.name }}</span>
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>
    }

      <!-- Approval Details Section - Show when approval is selected OR when we have single approval data -->
      @if ((selectedApproval() && getSelectedApprovalDetails()) || singleApprovalData()) {
      <div
        class="approval-details"
      >
        <!-- Header with approval name and delete action -->
        <div class="details-header">
          <div class="approval-info">
            <span class="approval-title">
              <span class="approval-icon-wrap approval-icon-wrap--attached" aria-hidden="true">
                <i class="wl_icon_complete"></i>
              </span>
              {{ singleApprovalData() ?
              (getSelectedApprovalDetails()?.approvalName + ' is currently
              attached') : (getSelectedApprovalDetails()?.name + ' was attached
              from setup') }}
            </span>
            @if (!singleApprovalData()) {
            <button
              class="btn-go-back"
              (click)="goBackToApprovalSelection()"
              matTooltip="Go back to approval selection"
            >
              <i class="wl_icon_back_to"></i>
            </button>
            }
            <!-- <div class="approval-status-badge" *ngIf="singleApprovalData()">
              <span class="status-text">Active</span>
            </div> -->
          </div>
          @if (singleApprovalData() && !isStatusComplete()) {
          <div
            class="approval-actions"
          >
            <button
              class="btn-delete-approval"
              (click)="openDeleteApprovalConfirmPopup()"
              matTooltip="Delete this approval process"
            >
              <i class="wl_icon_delete" aria-hidden="true"></i>
            </button>
          </div>
          }
        </div>

        <!-- Approval Paths -->
        @for (path of getSelectedApprovalDetails()?.approvalPaths; track path.path; let pathIndex = $index) {
        <div
          class="approval-paths"
        >
          <!-- Path Header -->
          <div class="path-header">
            <span class="path-label">Path {{ path.path }}</span>
             @if ((getSelectedApprovalDetails()?.approvalPaths?.length || 0) > 1 && path.pathStartStatus && !isStatusComplete()) {
            <button
              class="btn-close-path"
              (click)="removePath(pathIndex)"
            >
              ×
            </button>
            }
          </div>

          <!-- Start Approval Process Rule - Editable Status Dropdown -->
          <div class="start-rule">
            <div class="start-rule-head">
              <span class="approval-icon-wrap approval-icon-wrap--start" aria-hidden="true">
                <i class="wl_icon_status-icon"></i>
              </span>
              <span class="start-rule-label">Start trigger</span>
            </div>
            <div class="start-rule-body">
              <span class="rule-text"
                >Start Approval Process when the status is set to</span
              >
              <div class="start-rule-select-wrap">
                <ng-select
                  [items]="statusList()"
                  bindLabel="label"
                  bindValue="value"
                  [ngModel]="path.pathStartStatus || null"
                  (ngModelChange)="updatePathStartStatus(pathIndex, $event)"
                  [searchable]="true"
                  [clearable]="false"
                  [placeholder]="'Select status...'"
                  [disabled]="isStatusComplete()"
                  [class.invalid-field]="isApprovalPathStartStatusInvalid(pathIndex)"
                  class="status-dropdown"
                >
                </ng-select>
                <!-- Inline validation warning -->
                @if (isApprovalPathStartStatusInvalid(pathIndex)) {
                <div 
                  class="field-warning" 
                >
                  <span class="warning-icon">!</span>
                  <span class="warning-text">Start status is required</span>
                </div>
                }
              </div>
            </div>
          </div>

          <!-- Stages Summary -->
          <div class="stages-summary">
            <div class="stages-summary-head">
              <span class="approval-icon-wrap approval-icon-wrap--stages" aria-hidden="true">
                <i class="wl_icon_approvals"></i>
              </span>
              <span class="summary-label">Stages</span>
            </div>
            <div class="stages-overview" role="list">
              @for (stage of path.stages; track stage.stageNumber) {
              <div
                class="stage-overview-item"
                role="listitem"
              >
                <span class="stage-overview-step" aria-hidden="true"
                  >{{ stage.stageNumber }}</span
                >
                <span class="stage-name-overview">{{ stage.stageName }}</span>
                <span
                  class="stage-status-overview"
                  [ngClass]="stage.status | stageOverviewStatusClass"
                  >{{ stage.status | stageDisplayStatus }}</span
                >
              </div>
              }
            </div>
          </div>

          <!-- Detailed Stages -->
          <div class="stages-container">
            @for (stage of path.stages; track stage.stageNumber; let stageIndex = $index) {
            <div
              class="stage-item"
            >
              <div class="stage-header">
                <div class="stage-info">
                  <span class="stage-number"
                    >Stage {{ stage.stageNumber }}</span
                  >
                  <span class="stage-status"
                    >{{ stage.status | stageDisplayStatus }}</span
                  >
                </div>
                @if (path.stages.length > 1 && !isStatusComplete()) {
                <button
                  type="button"
                  class="btn-close-stage"
                  (click)="openApprovalStageRemoveConfirm(pathIndex, stageIndex)"
                  matTooltip="Remove this stage"
                  matTooltipPosition="above"
                  matTooltipClass="stage-tooltip"
                  aria-label="Remove stage"
                >
                  <i class="wl_icon_close" aria-hidden="true"></i>
                </button>
                }
              </div>

              <div class="stage-content">
                <!-- Stage Name - Editable Input -->
                <div class="stage-name">
                  <span class="name-label">Name:</span>
                  <input
                    type="text"
                    class="name-input"
                    [ngModel]="stage.stageName"
                    (ngModelChange)="updateStageName(pathIndex, stageIndex, $event)"
                    placeholder="Enter stage name"
                    [disabled]="isStatusComplete()"
                    [class.invalid-field]="isApprovalStageNameInvalid(pathIndex, stageIndex)"
                  />
                  <!-- Inline validation warning -->
                  @if (isApprovalStageNameInvalid(pathIndex, stageIndex)) {
                  <div 
                    class="field-warning" 
                  >
                    <span class="warning-icon">!</span>
                    <span class="warning-text">
                      {{ stage.stageName === 'New Stage' ? 'Please provide a meaningful stage name' : 'Stage name is required' }}
                    </span>
                  </div>
                  }
                </div>

                <!-- Approvers Section -->
                <div class="approvers-section">
                  <span class="approvers-label">Approvers</span>
                  <div class="approvers-divider"></div>

                  <!-- Selected Approvers with Remove Buttons -->
                  <div class="approvers-list">
                    @for (approver of stage.approvers; track approver._id; let approverIndex = $index) {
                    <div
                      class="approver-item"
                    >
                      <span class="approver-name">{{ approver.name }}</span>
                      @if (!isStatusComplete()) {
                      <button
                        class="btn-remove-approver"
                        (click)="removeApprover(pathIndex, stageIndex, approverIndex)"
                      >
                        ×
                      </button>
                      }
                    </div>
                    }
                  </div>

                  <!-- Add Approver Dropdown -->
                  <div
                    class="add-approver"
                    [class.invalid-field-container]="isApprovalStageApproversInvalid(pathIndex, stageIndex)"
                  >
                    <ng-select
                      #approverSelect
                      [items]="getAvailableAssigneesForApprovalStage(pathIndex, stageIndex)"
                      bindLabel="name"
                      bindValue="_id"
                      [ngModel]="null"
                      (ngModelChange)="addApprover(pathIndex, stageIndex, $event, approverSelect)"
                      [searchable]="true"
                      [clearable]="true"
                      [placeholder]="'Select approvers...'"
                      appendTo="body"
                      [disabled]="isStatusComplete()"
                      [class.invalid-field]="isApprovalStageApproversInvalid(pathIndex, stageIndex)"
                      class="assignee-dropdown"
                    >
                    </ng-select>
                    <!-- Inline validation warning -->
                    @if (isApprovalStageApproversInvalid(pathIndex, stageIndex)) {
                    <div 
                      class="field-warning" 
                    >
                      <span class="warning-icon">!</span>
                      <span class="warning-text">At least one approver is required</span>
                    </div>
                    }
                  </div>

                  <!-- Approval Condition - Checkbox -->
                  <div class="approval-condition">
                    <div class="condition-item">
                      <input
                        type="checkbox"
                        class="condition-checkbox"
                        [checked]="stage.isOneDecision"
                        (change)="updateStageOneDecision(pathIndex, stageIndex, $event)"
                        [disabled]="isStatusComplete()"
                      />
                      <span class="condition-text"
                        >Only one decision is required</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }

            <!-- Add New Stage Button -->
            @if (!isStatusComplete()) {
            <div class="add-stage-section">
              <button class="btn-add-stage" (click)="addNewStage(pathIndex)">
                <i class="wl_icon_add"></i> Add New Stage
              </button>
            </div>
            }
          </div>

          <!-- Rejection Handling - Editable Status Dropdown -->
          <div class="rejection-section">
            <span class="approval-icon-wrap approval-icon-wrap--reject" aria-hidden="true">
              <i class="wl_icon_feedback"></i>
            </span>
            <span class="rejection-label">If Rejected</span>
            <ng-select
              [items]="statusList()"
              bindLabel="label"
              bindValue="value"
              [ngModel]="path.rejectStatus"
              (ngModelChange)="updatePathRejectStatus(pathIndex, $event)"
              [searchable]="true"
              [clearable]="false"
              [placeholder]="'Select status...'"
              [disabled]="isStatusComplete()"
              [class.invalid-field]="isApprovalPathRejectStatusInvalid(pathIndex)"
              class="status-dropdown"
            >
            </ng-select>
            <!-- Inline validation warning -->
            @if (isApprovalPathRejectStatusInvalid(pathIndex)) {
            <div 
              class="field-warning" 
            >
              <span class="warning-icon">!</span>
              <span class="warning-text">Rejection status is required</span>
            </div>
            }
          </div>
        </div>
        }

        <!-- Add New Path Button -->
        @if (!isStatusComplete()) {
        <div class="add-path-section">
          <div class="divider"></div>
          <button class="btn-add-path" (click)="addNewPath()">
            <i class="wl_icon_add"></i> Add Path
          </button>
        </div>
        }
      </div>
      }
    </div>

    <!-- Validation Errors -->
    @if (showApprovalValidationErrors() && approvalValidationErrorsComputed().length > 0) {
    <div
      class="validation-errors"
    >
      <div class="error-title">Please fix the following errors:</div>
      <ul class="error-list">
        @for (error of approvalValidationErrorsComputed(); track error) {
        <li>
          {{ error }}
        </li>
        }
      </ul>
    </div>
    }

    <!-- Action Buttons - Fixed at bottom -->
    <div class="modal-actions">
      <button
        class="btn-save"
        [disabled]="!isApprovalFormValid() || isSavingApproval() || isStatusComplete()"
        (click)="saveApprovals()"
      >
        @if (isSavingApproval()) {
        <app-spinner [size]="16"></app-spinner>
        }
        @if (!isSavingApproval()) {
        <span
          >{{ singleApprovalData() ? 'Update Approval' : 'Save Approval'
          }}</span
        >
        }
      </button>
      <button
        class="btn-cancel"
        (click)="closeApprovalsModal()"
        [disabled]="isSavingApproval()"
      >
        Cancel
      </button>
    </div>
  </div>
</div>
}
